import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list (params) {
    let options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios.get(`${url}/villages`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/villages/${id}?include=neighborhoods`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function show (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/villages/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}

function add (villege) {
    const payload = jsona.serialize({
        stuff: villege,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/villages`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update (villege) {
    const payload = jsona.serialize({
        stuff: villege,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/villages/${villege.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy (id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/villages/${id}`, options);
}

export default {
    list,
    get,
    show,
    add,
    update,
    destroy
};

